/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssessmentManagementControllerCreateCompleteAssessmentRequestAssessment } from './assessmentManagementControllerCreateCompleteAssessmentRequestAssessment';
import { AssessmentManagementControllerCreateCompleteAssessmentRequestConfigsInner } from './assessmentManagementControllerCreateCompleteAssessmentRequestConfigsInner';
import { AssessmentManagementControllerCreateCompleteAssessmentRequestQuestionsInner } from './assessmentManagementControllerCreateCompleteAssessmentRequestQuestionsInner';
import { AssessmentManagementControllerCreateCompleteAssessmentRequestParticipantsInner } from './assessmentManagementControllerCreateCompleteAssessmentRequestParticipantsInner';
import { AssessmentManagementControllerCreateCompleteAssessmentRequestSectionsInner } from './assessmentManagementControllerCreateCompleteAssessmentRequestSectionsInner';


export interface AssessmentManagementControllerCreateCompleteAssessmentRequest { 
    assessment: AssessmentManagementControllerCreateCompleteAssessmentRequestAssessment;
    sections?: Array<AssessmentManagementControllerCreateCompleteAssessmentRequestSectionsInner>;
    questions?: Array<AssessmentManagementControllerCreateCompleteAssessmentRequestQuestionsInner>;
    participants?: Array<AssessmentManagementControllerCreateCompleteAssessmentRequestParticipantsInner>;
    configs?: Array<AssessmentManagementControllerCreateCompleteAssessmentRequestConfigsInner>;
    createdBy?: number;
    /**
     * Estado inicial del assessment (draft o active). Default: draft
     */
    status?: AssessmentManagementControllerCreateCompleteAssessmentRequest.StatusEnum;
    /**
     * Si es true, agrega automáticamente todos los empleados de la empresa como participantes. Si es false o no se envía, usa el array participants del request.
     */
    useCompanyParticipants?: boolean;
}
export namespace AssessmentManagementControllerCreateCompleteAssessmentRequest {
    export type StatusEnum = 'draft' | 'active';
    export const StatusEnum = {
        Draft: 'draft' as StatusEnum,
        Active: 'active' as StatusEnum
    };
}


